(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-retail-admin-data/edit-retailer/assets/javascripts/services/update.js') >= 0) return;  svs.modules.push('/components/marketplace-retail-admin-data/edit-retailer/assets/javascripts/services/update.js'); "use strict";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }

const {
  saveImageBase64,
  updateRetailer,
  updateGroup,
  updateGroupName
} = svs.components.marketplaceRetailAdminData.editRetailer.services;
const saveImageTask = (groupId, _ref) => {
  let {
    imageFile,
    imageCrop
  } = _ref;
  return callback => {
    if (!(imageFile && imageCrop)) {
      return callback(null, undefined);
    }
    saveImageBase64(groupId, imageFile, imageCrop, callback);
  };
};
const updateRetailerTask = data => callback => {
  updateRetailer(data, callback);
};
const updateGroupTask = (groupId, _ref2, publish) => {
  let {
    name,
    status
  } = _ref2;
  return callback => {
    if (publish) {
      return updateGroup(groupId, name, status, callback);
    }
    updateGroupName(groupId, name, callback);
  };
};
const updateTask = (groupId, data, publish, hasUnpublishPerm) => (response, callback) => {
  const imagePath = response ? response.path : undefined;
  const coverImage = imagePath ? {
    path: imagePath
  } : data.coverImage;
  const tasks = [updateRetailerTask(_objectSpread(_objectSpread({}, data), {}, {
    coverImage
  }))];
  if (hasUnpublishPerm) {
    tasks.push(updateGroupTask(groupId, data, publish));
  }
  async.parallel(tasks, callback);
};
const update = (groupId, data, publish, hasUnpublishPerm, callback) => {
  async.waterfall([saveImageTask(groupId, data), updateTask(groupId, data, publish, hasUnpublishPerm)], (err, result) => {
    if (err) {
      return callback(err);
    }
    return callback(null, result);
  });
};
setGlobal('svs.components.marketplaceRetailAdminData.editRetailer.services.update', update);
 })(window);